import { Directive, ElementRef, OnDestroy } from '@angular/core';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Directive({
  selector: '[appMaskDate]'
})
export class MaskDateDirective implements OnDestroy {
  mask = {
    guide: true,
    showMask: true,
    keepCharPositions: true,
    mask: [/[0-3]/, /\d/, '.', /[0-1]/, /\d/, '.', /[0-2]/, /\d/, /\d/, /\d/] // dd.mm.yyyy
  };
  maskedInputController;

  constructor(private element: ElementRef) {
    this.maskedInputController = textMask.maskInput({
      inputElement: this.element.nativeElement,
      ...this.mask
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
  }
}
